export const PACKAGE_TYPE = {
  HOTEL_FLIGHT: 'HOTEL_FLIGHT',
  HOTEL_FLIGHT_CAR: 'HOTEL_FLIGHT_CAR',
  FLIGHT_CAR: 'FLIGHT_CAR',
}

const determinePackageType = (bundleComponents) => {
  if (!bundleComponents || bundleComponents?.length === 0) {
    return null
  }
  const components = bundleComponents
  let hasHotel = false
  let hasFlight = false
  let hasCar = false
  let packageType = null

  if (components) {
    components.forEach((component) => {
      switch (component.type) {
        case 'STAY':
          hasHotel = true
          break
        case 'FLY':
          hasFlight = true
          break
        case 'DRIVE':
          hasCar = true
          break
      }
    })
    if (hasHotel && hasFlight && hasCar) {
      packageType = PACKAGE_TYPE.HOTEL_FLIGHT_CAR
    } else if (hasHotel && hasFlight) {
      packageType = PACKAGE_TYPE.HOTEL_FLIGHT
    } else if (hasFlight && hasCar) {
      packageType = PACKAGE_TYPE.FLIGHT_CAR
    }
  }

  return packageType
}

export const getPackageType = (bundleComponents) => {
  return determinePackageType(bundleComponents)
}
